module.exports = __webpack_public_path__ + "img/hammer.salvaged.a25d125e.png";